import i18n from '@/locales'
export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('common_619'),
        action: obj => {
          this.createDialog('SetDiscountDialog', {
            data: [obj],
            title: i18n.t('common_619'),
            onManager: this.onManager,
            refresh: this.refresh,
          })
        },
      },
    ]
  },
}
